module.exports = __webpack_public_path__ + "img/img68.4f00255e.png";